import FichaTecnicaWorkflowPage from './pages/FichaTecnicaWorkflowPage.vue'
import FichaTecnicaTarefaPage from './pages/FichaTecnicaTarefaPage.vue';

const routes = [
  {
    path: 'ficha-tecnica-workflow/:pco_workflow_id',
    name: 'ficha-tecnica-workflow',
    component: FichaTecnicaWorkflowPage
  },
  {
    path: 'ficha-tecnica-tarefa/:pco_tarefa_id',
    name: 'ficha-tecnica-tarefa',
    component: FichaTecnicaTarefaPage
  }
];

export default routes;